var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgExitFullScreen = function SvgExitFullScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 22 22",
    fill: "none"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M17.417 8.25v1.833h-4.584a.917.917 0 01-.916-.916V4.583h1.833V8.25h3.667zM4.583 8.25v1.833h4.584c.506 0 .916-.41.916-.916V4.583H8.25V8.25H4.583zM17.417 13.75v-1.833h-4.584a.917.917 0 00-.916.916v4.584h1.833V13.75h3.667zM4.583 13.75v-1.833h4.584c.506 0 .916.41.916.916v4.584H8.25V13.75H4.583z"
  })));
};
export default SvgExitFullScreen;